/**
 * FreehandManager - Facade-facing API for the freehand drawing settings.
 *
 * The settings live on the viewer, where FreehandDragger reads them.
 */

import type { DRDrawingViewer } from "../DRDrawingViewer";

export class FreehandManager {
  constructor(private viewer: DRDrawingViewer) {}

  /**
   * Replace a stroke matching a regular shape by that shape (line, circle,
   * ellipse, polygon) when the pen is lifted.
   */
  setShapeRecognition(enabled: boolean): void {
    this.viewer.shapeRecognition = enabled;
  }

  /** Close a polyline whose end point is near its start point. */
  setAutoClose(enabled: boolean): void {
    this.viewer.autoClose = enabled;
  }

  /**
   * Set the smoothening epsilon.
   * @param value Epsilon value in screen pixels (0 = disabled)
   */
  setSmoothen(value: number): void {
    this.viewer.smoothen = value;
  }
}
